import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroBullets, heroImage, product } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream pb-14 pt-14 md:pb-20 md:pt-20" data-id="element-110" data-mp="9llat1xpw6pm">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-111" data-mp="4m8kg77n0hia">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="text-[0.7rem] font-bold uppercase tracking-[0.22em] text-gold-700" data-id="element-112" data-mp="129h6c3bjvskt">
          Sistema de recursos para el duelo · 6 a 18 años
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.9rem] font-extrabold leading-[1.02] tracking-tight text-plum-700 sm:text-6xl md:text-[4.2rem]" data-id="element-113" data-mp="ncztf7npq5w5">
          El Puente <span className="italic text-gold-700" data-id="element-114" data-mp="3j9agbasosm43">del Adiós</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.1,
        ease
      }} className="mx-auto mt-6 max-w-2xl text-xl leading-relaxed text-muted md:text-[1.35rem]" data-id="element-115" data-mp="3o73o289n1o6h">
          {product.subheadline}
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.16,
        ease
      }} src={heroImage} alt="Los 4 tomos de El Puente del Adiós, las 30 tarjetas Cartas para Sanar y los 3 bonos" className="mx-auto mt-12 w-full max-w-3xl" width={1256} height={1256} data-id="element-116" data-mp="30fy9rxjcj3ya" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.22,
        ease
      }} className="mx-auto mt-12 max-w-3xl" data-id="element-117" data-mp="2hlj983hdz38c">
          <div className="mx-auto max-w-2xl space-y-3 text-lg leading-relaxed text-ink" data-id="element-118" data-mp="nbl3anaa4kbi">
            {product.description.map(line => <p key={line} data-id="element-119" data-mp="id00cg3n7mjd">{line}</p>)}
          </div>

          <ul className="mx-auto mt-9 flex max-w-2xl flex-wrap items-center justify-center gap-x-6 gap-y-2.5 text-sm font-semibold text-ink" data-id="element-120" data-mp="ddne9xklijhu">
            {heroBullets.map(bullet => <li key={bullet} className="inline-flex items-center gap-2" data-id="element-121" data-mp="1622jxthu7pgi">
                <span className="h-1.5 w-1.5 rounded-full bg-teal-500" aria-hidden="true" data-id="element-122" data-mp="15zzvvf08w6ef" />
                {bullet}
              </li>)}
          </ul>

          <div className="mt-11" data-id="element-123" data-mp="x0cu2s3lsyku">
            <CtaButton size="xl" href="#precio" data-id="element-124" data-mp="x3h1dycd8afq">
              {product.cta}
            </CtaButton>
            <p className="mt-5 text-sm text-muted" data-id="element-125" data-mp="3lqm4435bldx1">
              Pago único · Acceso inmediato · Garantía de 7 días
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}